import { noop } from 'lodash';
import styled from 'styled-components';

import { Patient, PatientEntitlementType } from '@dreryk/egabinet-patient-frontend-api';

import { PatientEntitlementTypeSelect } from './PatientEntitlementTypeSelect';
import { usePatientEntitlementTypeSelectorFormController } from './PatientEntitlementTypeSelectorForm.hooks';
import { PatientEntitlementTypeSelectorFormRenderer } from './PatientEntitlementTypeSelectorForm.types';

const StyledForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 1em;
`;

StyledForm.displayName = 'StyledForm';

type PatientEntitlementTypeSelectorFormProps = {
   readonly patientId: Patient['id'];
   readonly predefinedPatientEntitlementType?: PatientEntitlementType;
   readonly children: PatientEntitlementTypeSelectorFormRenderer;
};

export const PatientEntitlementTypeSelectorForm = (props: PatientEntitlementTypeSelectorFormProps): JSX.Element => {
   const { register, handleSubmit, watch } = usePatientEntitlementTypeSelectorFormController({
      initialPatientEntitlementType: props.predefinedPatientEntitlementType,
   });

   const selectedPatientEntitlementType = watch('patientEntitlementType');

   const submit = handleSubmit(noop);

   return (
      <StyledForm noValidate>
         <PatientEntitlementTypeSelect
            register={register}
            patientId={props.patientId}
            disabled={Boolean(props.predefinedPatientEntitlementType)}
         />
         {props.children({
            submit: submit,
            selectedPatientEntitlementType: selectedPatientEntitlementType,
         })}
      </StyledForm>
   );
};
